var LoadLibrary, GeoFramework;

LoadLibrary = function(){};
GeoFramework = function(){};

LoadLibrary.prototype.init = function(library_url, callback){
  this.library_url = library_url; 
 
  jQuery.getScript(this.library_url, function(){
    callback();    
    
    jQuery('head').append('<link rel="stylesheet" type="text/css" href="//cloud.github.com/downloads/lafeber/world-flags-sprite/flags32.css"></link>')
  });
};

GeoFramework.prototype.setStyleClass = function(){
  return 'flag '+geoplugin_countryCode().toLowerCase();
};

GeoFramework.prototype.setCountryName = function(){
  return geoplugin_countryName();
};

GeoFramework.prototype.createHTML = function(target, style_class, country){
  target.append('<span class="f32"><span class="'+style_class+'" style="vertical-align: middle; margin-right: 10px;"></span><span>'+country+'</span></span>');
};

//INIT
var lb = new LoadLibrary();

lb.init('http://www.geoplugin.net/javascript.gp', function(){  
  var geo = new GeoFramework();
  var style_class = geo.setStyleClass();
  var country = geo.setCountryName();
  var target = jQuery('#country');
  geo.createHTML(target, style_class, country);
});
